RivalIQ.apps.Registration.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.LandscapeCompanies = Backbone.Collection.extend({
        model: App.models.LandscapeCompany
    });
});
